import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { MdMenu, MdClose } from 'react-icons/md';
import DropdownMenu, {
  DropdownItemGroup,
  DropdownItem,
} from '@atlaskit/dropdown-menu';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'recompose';
import { withFirebase, isEmpty } from 'react-redux-firebase';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import { startsWith, size } from 'lodash';
import { authSelector } from '@selectors/firebase';
import {
  carrierNameSelector,
  dotNumberSelector,
  identityBaseUrlSelector,
  userEmailSelector,
} from '@selectors/global';
import './NavigationBar.scss';
import { Amplitude } from '@amplitude/react-amplitude';
import { fireTrackingEvent } from '@utils/trackingEventMethods';
import { isMobile } from 'react-device-detect';
const Logo = require('@assets/images/parade-logo.svg');
const White_Logo = require('@assets/images/parade_logo_full_white.svg');
var rootEventName = `NavigationBar`;
const helpCenterEvent = 'clickHelpCenter';
const logOutEvent = 'clickLogOut';
const NavigationBar = ({
  auth,
  firebase,
  dotNumber,
  carrier_name,
  identityUrl,
  userEmail,
}) => {
  const [buttonTrigger, setButtonTrigger] = useState(<MdMenu size="24px" />);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  //HARD CODE SECTION -- start
  const hidden_dotNumber = '2557812';
  const hardCodeTestCase = dotNumber == hidden_dotNumber;
  //HARD CODE SECTION -- end
  const pathname = window.location.pathname;
  const authorized = !isEmpty(auth);
  const onTriggerClickHandler = v => {
    if (isMobile) {
      if (v.isOpen === true) {
        setButtonTrigger(<MdClose size="24px" />);
        setIsMenuOpen(true);
        document.body.setAttribute('style', 'overflow: hidden !important');
      } else {
        setButtonTrigger(<MdMenu size="24px" />);
        setIsMenuOpen(false);
        document.body.style.overflow = '';
      }
    }
  };
  const carrierName = () =>
    size(carrier_name) > 0 && (
      <span className="menu-item fixed">{carrier_name}</span>
    );
  const hrefUrl = `${identityUrl}/carrier_users/users/`;
  const carrierResourcesHrefUrl = `http://help.carriers.parade.ai/en/`;
  const desktopDropdownMenu = () => {
    var localRootEventName = `${rootEventName}.DesktopDropdownMenu`;
    return (
      <DropdownItemGroup title={carrierName()}>
        {userEmail && (
          <DropdownItem className="menu-item user-email" isDisabled>
            {userEmail}
          </DropdownItem>
        )}
        <NavLink to="/manage/profile">
          <DropdownItem className="menu-item">Carrier Profile</DropdownItem>
        </NavLink>
        <a href={hrefUrl} target="_blank">
          <DropdownItem className="menu-item">User Management</DropdownItem>
        </a>
        <Amplitude
          eventProperties={inheritedProps => ({
            ...inheritedProps,
          })}
        >
          {({ logEvent }) => (
            <a
              href={carrierResourcesHrefUrl}
              target="_blank"
              onClick={() => fireTrackingEvent(logEvent, `${localRootEventName}.${helpCenterEvent}`)}
            >
              <DropdownItem className="menu-item">Help Center</DropdownItem>
            </a>
          )}
        </Amplitude>
        {!isEmpty(auth) && (
          <Amplitude
            eventProperties={inheritedProps => ({
              ...inheritedProps,
            })}
          >
            {({ logEvent }) => (
              <DropdownItem
                className="menu-item"
                onClick={() => {
                  firebase.logout();
                  fireTrackingEvent(logEvent, `${localRootEventName}.${logOutEvent}`);
                }}
              >
                Log out
              </DropdownItem>
            )}
          </Amplitude>
        )}
      </DropdownItemGroup>
    );
  };
  const mobileDropdownMenu = () => {
    var localRootEventName = `${rootEventName}.MobileDropdownMenu`;
    return (
      <div className="dropdown-mobile-view">
        <div className="dropdown-mobile-view__inner-wrapper">
          {(carrier_name || userEmail) && (
            <>
              {size(carrier_name) > 0 && (
                <span className="user-info-label">{carrier_name}</span>
              )}
              {userEmail && (
                <span className="user-info-email">{userEmail}</span>
              )}
              <div className="dropdown-mobile-view__inner-wrapper__rectangle" />
            </>
          )}
          <NavLink className="nav-link" to="/direct">
            My Partners
          </NavLink>
          <div className="dropdown-mobile-view__inner-wrapper__rectangle"/>
          <NavLink className="nav-link" to="/search">
            Search
          </NavLink>
          <div className="dropdown-mobile-view__inner-wrapper__rectangle"/>
          <NavLink className="nav-link" to="/manage/profile">
            Carrier Profile
          </NavLink>
          <Amplitude
            eventProperties={inheritedProps => ({
              ...inheritedProps,
            })}
          >
            {({ logEvent }) => (
              <a
                href={carrierResourcesHrefUrl}
                target="_blank"
                onClick={() => fireTrackingEvent(logEvent, `${localRootEventName}.${helpCenterEvent}`)}
              >
                Help Center
              </a>
            )}
          </Amplitude>
          {!isEmpty(auth) && (
            <Amplitude
              eventProperties={inheritedProps => ({
                ...inheritedProps,
              })}
            >
              {({ logEvent }) => (
                <div
                  className="menu-item"
                  onMouseDown={() => {
                    firebase.logout();
                    fireTrackingEvent(logEvent, `${localRootEventName}.${logOutEvent}`);
                  }}
                >
                  Log out
                </div>
              )}
            </Amplitude>
          )}
        </div>
      </div>
    );
  };
  if (!authorized || pathname === '/d' || startsWith(pathname, '/d/')) {
    return null;
  }
  return (
    <>
      <div
        id="global-navigation-bar"
        className={`navigation-bar flex flex-between ${
          isMobile ? 'mobile-view' : ''
        }`}
      >
        <div className="logo-wrapper">
          <img className="logo" src={isMobile ? White_Logo : Logo} />
        </div>
        <div className="navigation-bar__links-wrapper">
          <ul className="navigation-bar__links">
            {!isMobile && (
              <>
                <li>
                  <NavLink className="nav-link" to="/direct">
                    My Partners
                  </NavLink>
                </li>
                <li>
                  <NavLink className="nav-link" to="/search">
                    Search
                  </NavLink>
                </li>
              </>
            )}
            <li>
              <div
                className={`${
                  isMobile ? 'hamburger-button-mobile-view' : 'hamburger-button'
                }`}
              >
                <DropdownMenu
                  trigger={buttonTrigger}
                  onOpenChange={onTriggerClickHandler}
                  position="bottom right"
                >
                  {!isMobile && desktopDropdownMenu()}
                </DropdownMenu>
              </div>
            </li>
          </ul>
        </div>
      </div>
      {isMobile && isMenuOpen === true && mobileDropdownMenu()}
    </>
  );
};

NavigationBar.propTypes = {
  firebase: PropTypes.shape({
    logout: PropTypes.func.isRequired,
  }),
  auth: PropTypes.object,
  dotNumber: PropTypes.any,
  carrier_name: PropTypes.any,
  identityUrl: PropTypes.any,
  userEmail: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  auth: authSelector,
  dotNumber: dotNumberSelector,
  carrier_name: carrierNameSelector,
  identityUrl: identityBaseUrlSelector,
  userEmail: userEmailSelector,
});

const enhance = compose(
  withRouter,
  withFirebase,
  connect(
    mapStateToProps,
    null,
  ),
);

export default enhance(NavigationBar);
